export const NumberGroupingFormatter = (value) => {
    const valueAsNumber = parseFloat(value);

    if (!value || isNaN(valueAsNumber)) return value;

    return value.toString().replace(/(\d)(?=(\d{3})+\b)/g, "$1 ");
};



// WEBPACK FOOTER //
// ../source/common/utils/filters/numberGroupingFormatter.js